let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kBThy")).then(() => parcelRequire('3ol7V'));